var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "poppins",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('popup-handler'), _c('nav-bar-expert'), _c('router-view', {
    staticStyle: {
      "min-height": "100%"
    }
  }), _c('success-message-handler')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }